export const palette = {
  blue1: 'rgb(64, 112, 154)', // #40709A
  gray1: '#1B2634',
  gray2: '#0D1A2B',
  gray3: 'rgb(57, 63, 75)', // #393F4B
  gray4: 'rgb(24, 32, 46)', // #18202E
  gray5: '#e1e1e1',
  gray6: '#10171f',
  gray7: '#767D85',
  white1: '#e8e8e8',
  orange1: 'rgb(224, 151, 56)', // #E09738
  red1: 'rgb(196, 52, 52)', // #C43434
  green1: '#279673',
}

export default palette
